import { defineMessages } from 'react-intl';

export const libraryCreateFilterMessages = defineMessages({
  cancel: {
    defaultMessage: 'Cancel',
    id: 'TE+RwjapDK',
    description: 'Secondary action to dismiss a create dialog without saving',
  },
  closeDialogAria: {
    defaultMessage: 'Close',
    id: 'uJfpAt5ej3',
    description: 'Aria label for closing a modal dialog',
  },
  allDocumentsLabel: {
    defaultMessage: 'Documents',
    id: 'ZjFxnMLQNV',
    description: 'Library filter bar title when no collection filter is applied',
  },
  itemCount: {
    defaultMessage: '{count, plural, one {# item} other {# items}}',
    id: 'pXv3XQw9+j',
    description: 'Summary count of library items next to the sort control',
  },
  processingCount: {
    defaultMessage: '({count, number} processing)',
    id: 'DuEuUk8eki',
    description: 'Suffix showing how many items are still processing',
  },
  sortDateAdded: {
    defaultMessage: 'Date added',
    id: 'CziCNmA88w',
    description: 'Library sort option: order by date added',
  },
  sortName: {
    defaultMessage: 'Name',
    id: 'wi8EtA11Mc',
    description: 'Library sort option: alphabetical by name',
  },
  sortFileType: {
    defaultMessage: 'File type',
    id: 'PGRXfq2nZ/',
    description: 'Library sort option: group or order by file type',
  },
  clearCollectionFilterAria: {
    defaultMessage: 'Clear {collectionName} filter',
    id: '3ipqrWKZyH',
    description: 'Aria label for clearing the active collection filter chip',
  },
  createCollectionTitle: {
    defaultMessage: 'Create a collection',
    id: 'TBOfw7JyNN',
    description: 'Heading for the create collection modal',
  },
  createCollectionSubmit: {
    defaultMessage: 'Create Collection',
    id: 'mBgSPQGhtq',
    description: 'Primary submit button for creating a new collection',
  },
  collectionNameLabel: {
    defaultMessage: 'Name',
    id: 'ICWkJk5LUZ',
    description: 'Label for the collection name field',
  },
  collectionNamePlaceholder: {
    defaultMessage: 'e.g., Diabetes Guidelines',
    id: 'FZ+V4iTPsN',
    description: 'Placeholder example for a new collection name',
  },
  collectionDescriptionLabel: {
    defaultMessage: 'Description (optional)',
    id: 'ee/ItqsEqb',
    description: 'Label for the optional collection description field',
  },
  collectionDescriptionPlaceholder: {
    defaultMessage: 'What documents will this collection contain?',
    id: '+4XJ+b22RR',
    description: 'Placeholder guiding what to enter in collection description',
  },
  teamCollectionLabel: {
    defaultMessage: 'Team Collection',
    id: '9tQr4Uwxw5',
    description: 'Label for the team-shared collection toggle',
  },
  visibleToAllTeamMembers: {
    defaultMessage: 'Visible to all {teamName} members',
    id: 'I8Azd7e42v',
    description: 'Helper text for team collection visibility',
  },
  collectionSharingNotEnabled: {
    defaultMessage: 'Your team admin hasn’t enabled collection sharing',
    id: 'FcBdJXmdU3',
    description:
      'Tooltip when a member cannot create a team collection because Allow collection sharing is off',
  },
  teamNameFallback: {
    defaultMessage: 'Team',
    id: 'j/0W1ehTDR',
    description: 'Short fallback label when the team display name is unavailable',
  },
  duplicateCollectionNameError: {
    defaultMessage: 'A collection with this name already exists',
    id: '5xOYmzTTrH',
    description: 'Inline error when the chosen collection name conflicts (409)',
  },
  createCollectionGenericError: {
    defaultMessage: 'Failed to create collection. Please try again.',
    id: 'TxcCrzvhNx',
    description: 'Generic inline error when collection creation fails',
  },
  chooseCollectionIconAria: {
    defaultMessage: 'Choose collection icon',
    id: 'oDU3GlKfmd',
    description: 'Aria label for opening the collection icon picker',
  },
  toastCollectionCreatedTitle: {
    defaultMessage: 'Collection created',
    id: 'i5H1NpJPpg',
    description: 'Toast title after a collection is created',
  },
  toastDocumentsAddedToCollection: {
    defaultMessage:
      'Added {docCount, plural, one {# document} other {# documents}} to {collectionName}',
    id: 'K/mZrXxQfy',
    description:
      'Toast body after documents are linked to the new collection; collectionName is user-chosen',
  },
  toastCollectionCreatedAddDocumentsFailed: {
    defaultMessage: 'But we couldn’t add your document. Try adding it from the library.',
    id: 'gliX1d7HCP',
    description:
      'Toast body when the collection was created but attaching pending documents failed',
  },
});
